import React, { useEffect } from "react";
import CountUp from "react-countup";
import { Link } from "react-router-dom";
import { Card, CardBody, Col } from "reactstrap";
import { getStatsTransactionsQuery } from "../../queries";
import { useQuery } from "@tanstack/react-query";
import { useTranslation } from "react-i18next";

const Widgets = ({ dateRange, setData, sellerId }) => {
  const { t } = useTranslation();
  const { data: stats } = useQuery({
    ...getStatsTransactionsQuery({
      fromCreatedAt: dateRange?.[0],
      toCreatedAt: dateRange?.[1],
      sellerId,
    }),
  });

  const ecomWidgets = [
    {
      id: 3,
      cardColor: "success",
      label: t("Total Payment Amount"),
      counter: (stats?.data?.data.totalAmountPayment || 0) / 100,
      bgcolor: "warning",
      icon: "bx bx-dollar-circle",
      prefix: "",
      suffix: " UZS",
      decimals: 2,
    },
    {
      id: 2,
      cardColor: "secondary",
      label: t("Transactions Amount"),
      counter: (stats?.data?.data.totalAmountTransactions || 0) / 100,
      bgcolor: "info",
      icon: "bx bx-dollar-circle",
      prefix: "",
      separator: ",",
      suffix: " UZS",
      decimals: 2,
    },
    {
      id: 4,
      cardColor: "primary",
      label: t("Total Amount Commission"),
      counter: (stats?.data?.data.totalAmountCommissions || 0) / 100,
      bgcolor: "success",
      icon: "bx bx-dollar-circle",
      suffix: " UZS",
    },
    {
      id: 1,
      cardColor: "primary",
      label: t("Total Transactions"),
      counter: stats?.data?.data.transactionsCount,
      bgcolor: "success",
      icon: "bx bx-dollar-circle",
    },
  ];

  useEffect(() => {
    if (stats && setData) {
      setData(stats?.data?.data);
    }
  }, [stats, setData]);

  return (
    <React.Fragment>
      {stats &&
        ecomWidgets.map((item, key) => (
          <Col xl={3} md={6} key={key}>
            <Card className="card-animate">
              <CardBody>
                <div className="d-flex align-items-center">
                  <div className="flex-grow-1 overflow-hidden">
                    <p className="text-uppercase fw-bold text-muted text-truncate mb-0 fs-12">
                      {item.label}
                    </p>
                  </div>
                </div>
                <div className="d-flex align-items-end justify-content-between mt-4">
                  <div>
                    <h4 className="fs-22 fw-semibold ff-secondary mb-4">
                      <span className="counter-value" data-target="559.25" style={{ fontSize: "16px" }}>
                        <CountUp
                          start={0}
                          prefix={item.prefix}
                          suffix={item.suffix}
                          separator={item.separator}
                          end={item.counter}
                          decimals={item.decimals}
                          duration={4}
                        />
                      </span>
                    </h4>
                    <Link to="#" className="text-decoration-underline">
                      {item.link}
                    </Link>
                  </div>
                  <div className="avatar-sm flex-shrink-0">
                    <span
                      className={
                        "avatar-title rounded fs-3 bg-" +
                        item.bgcolor +
                        "-subtle"
                      }
                    >
                      <i className={`text-${item.bgcolor} ${item.icon}`}></i>
                    </span>
                  </div>
                </div>
              </CardBody>
            </Card>
          </Col>
        ))}
    </React.Fragment>
  );
};

export default Widgets;
